import React, { useEffect } from 'react';
import {
	Card,
	useAjax,
	XhrStatus,
} from '@bosch/bt-ui';

import './CSRManagementPage.css';
import { useNavigate } from 'react-router-dom';
import withErrorHandler from '../../components/ErrorHandler';
import RestfulCallout from '../../components/RestfulCallout';
import RestfulCallLoading from '../../components/RestfulCallLoading';
import CSRManagementPageTable from './CSRManagementPageTable';

const CSRManagementPage = (props) => {
	const {
		token,
		isLoggedIn
	} = props;

	const navigate = useNavigate();
	const [returnResult, status, getCSRInfo, response] = useAjax(XhrStatus.InProgress);
	
	useEffect(
		() => {
			// If useAjax(XhrStatus.InProgress) and not login yet, it will show 401
			// So we need to make sure token is avaliable to continue...
			if (token?.token) {
				if(isLoggedIn()) {
					getCSRInfo('GET', SUPPORTCONSOLE_API_URL + '/api/csrmanagement/v1/csrs/getall', null, undefined, { 'Authorization': 'Bearer ' + token.token });
				}
				else {
					navigate('/');
				}
			}
		},
		[token, getCSRInfo, isLoggedIn, navigate]
	);

	return (
		<Card
			htmlAttributes={{
				id: 'csr-management',
				className: 'csr-management-page'
			}}
		>
			<RestfulCallout status={status} response={response} returnObj={returnResult} hideSuccess={true} />
			{
				status === XhrStatus.Finished && <CSRManagementPageTable token={token} isLoggedIn={isLoggedIn} returnResult={returnResult} />
			}
			<RestfulCallLoading status={status} />
		</Card>
	);
};

export default withErrorHandler(React.memo(CSRManagementPage));